// Custom behavior is scoped to a Shopify section, with reversible ownership.
const coSectionControllers = new WeakMap();
const coMotionPreference = window.matchMedia("(prefers-reduced-motion: reduce)");

function initializeCoSection(root) {
  if (coSectionControllers.has(root) || !window.gsap || !window.ScrollTrigger) return;
  // Do not attach Cobalt controllers to unrelated Dawn, app or quiz sections.
  if (!root.querySelector('.coFade, .coFadeIn, .co_home_section_1-slider, .co_home_section_3-slider, .co_product_section_4-slider, .co_home_section_8-slider, .co_ourstory_section_1-tabs, .co_faq_section_3')) return;
  const events = new AbortController();
  const sliders = [];
  const restores = [];
  const reducedMotion = coMotionPreference.matches;
  let context;
  const listen = (element, type, handler) => {
    element.addEventListener(type, (event) => context.add(() => handler.call(element, event)), { signal: events.signal });
  };
  function updateToggle(heading, expanded) {
    heading.setAttribute("aria-expanded", String(expanded));
    if (heading.nextElementSibling) heading.nextElementSibling.inert = !expanded;
  }
  function makeToggle(heading, panel, expanded, suffix) {
    if (!panel) return;
    const attributes = ["role", "tabindex", "aria-expanded", "aria-controls"];
    const previous = attributes.map((key) => [key, heading.getAttribute(key)]);
    const oldId = panel.id;
    const oldInert = panel.inert;
    const oldClass = panel.className;
    const parentClass = heading.parentElement.className;
    if (!panel.id) panel.id = root.id + "-answer-" + suffix;
    heading.setAttribute("role", "button");
    heading.setAttribute("tabindex", "0");
    heading.setAttribute("aria-controls", panel.id);
    updateToggle(heading, expanded);
    listen(heading, "keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.click();
      }
    });
    restores.push(() => {
      previous.forEach(([key, value]) => value === null ? heading.removeAttribute(key) : heading.setAttribute(key, value));
      panel.id = oldId;
      panel.inert = oldInert;
      panel.className = oldClass;
      heading.parentElement.className = parentClass;
    });
  }
  context = gsap.context(() => {
  coFadeStale(".coFade", root);
  coFadeIn(".coFadeIn", root);

  // coMoveOnScroll('.co_home_section_4-image img', '.co_home_section_4', '.co_home_section_4', 0, 5);

  const HeroSlider = root.querySelector(".co_home_section_1-slider");
  if (HeroSlider && typeof Flickity !== "undefined") {
    const HeroSliderFlkty = new Flickity(HeroSlider, {
      // options
      // cellAlign: 'center',
      resize: true,
      imagesLoaded: true,
      contain: true,
      wrapAround: true,
      selectedAttraction: 0.1,
      friction: 1.2,
      pageDots: false,
      autoPlay: reducedMotion ? false : 10000,
      // addaptiveHeight: true
      // setGallerySize: false
    });
    sliders.push(HeroSliderFlkty);
  }

  const HeroSliderBest = root.querySelector(".co_home_section_3-slider");
  if (HeroSliderBest && typeof Splide !== "undefined") {
    var splideBest = new Splide(HeroSliderBest, {
      type: "loop",
      perPage: 3,
      focus: "center",
      pagination: false,
      // clones: 0,
      updateOnMove: true,
      // omitEnd: true,
      breakpoints: {
        1000: {
          perPage: 1,
        },
      },
    });

    // splideBest.on('overflow', function (isOverflow) {
    //     // Reset the carousel position
    //     splideBest.go(1);

    //     splideBest.options = {
    //         arrows: isOverflow,
    //         // pagination: isOverflow,
    //         drag: isOverflow,
    //         clones: isOverflow ? undefined : 1, // Toggle clones
    //     };
    // });

    splideBest.mount();
    sliders.push(splideBest);
  }

  const ProductSec4Slider = root.querySelector(
    ".co_product_section_4-slider"
  );
  if (ProductSec4Slider && typeof Splide !== "undefined") {
    var Product4Slider = new Splide(ProductSec4Slider, {
      type: "loop",
      perPage: 2,
      perMove: 1,
      autoplay: reducedMotion ? false : true,
      pauseOnHover: true,
      pauseOnFocus: true,
      keyboard: "focused",
      interval: 3000,
      pagination: false,
      arrows: false,
      speed: 800,
      clones: 0,
      updateOnMove: true,
      breakpoints: {
        500: {
          perPage: 1,
        },
      },
    });

    Product4Slider.on("overflow", function (isOverflow) {
      Product4Slider.go(0);
      if (!isOverflow) {
        ProductSec4Slider.classList.add("loop-no-drag");

        Product4Slider.options = {
          drag: isOverflow,
          clones: 0,
        };
      } else {
        Product4Slider.options = {
          clones: 2, // Toggle clones
        };
      }
    });

    Product4Slider.mount();
    sliders.push(Product4Slider);
  }

  const HomeSliderIngr = root.querySelector(".co_home_section_8-slider");
  if (HomeSliderIngr && typeof Splide !== "undefined") {
    var splideIngr = new Splide(HomeSliderIngr, {
      type: "loop",
      perPage: 5,
      speed: 600,
      // snap: true,
      updateOnMove: true,
      // autoWidth: true,
      focus: "center",
      pagination: false,
      // omitEnd: true,
      breakpoints: {
        1000: {
          perPage: 3,
        },
        749: {
          perPage: 1,
        },
      },
    });

    splideIngr.mount();
    sliders.push(splideIngr);

    // splideIngr.on("mouseover", function (slide) { // listen for "click" event: fired when the user clicks any slide

    //     if (slide.slide.classList.contains('is-active')) {
    //         slide.slide.classList.add('active');
    //     }
    //     splideIngr.go(slide.index);
    // });

    // splideIngr.on("click", function (slide) { // listen for "click" event: fired when the user clicks any slide

    //     if (slide.slide.classList.contains('is-active') && slide.slide.classList.contains('active')) {
    //         slide.slide.classList.remove('active');
    //     }
    //     // splideIngr.go(slide.index);
    // });

    var ingrItems = HomeSliderIngr.querySelectorAll(".co_home_section_8-slide");
    ingrItems.forEach(function (ingrItem, index) {
      if (window.matchMedia("(max-width: 750px)").matches) {
        // listen(ingrItem, "click", function (e) {
        //   e.preventDefault();
        //   if (this.classList.contains("is-active")) {
        //     this.classList.add("active");
        //   }
        // });
        listen(ingrItem, "click", function (e) {
          e.preventDefault();
          if (
            this.classList.contains("is-active") &&
            this.classList.contains("active")
          ) {
            this.classList.remove("active");
          } else {
            this.classList.add("active");
          }
        });
      } else {
        listen(ingrItem, "mouseover", function (e) {
          e.preventDefault();
          if (this.classList.contains("is-active")) {
            this.classList.add("active");
          }
        });
        listen(ingrItem, "mouseleave", function (e) {
          e.preventDefault();
          if (this.classList.contains("is-active")) {
            this.classList.remove("active");
          }
        });
        listen(ingrItem, "click", function (e) {
          e.preventDefault();
          if (
            this.classList.contains("is-active") &&
            this.classList.contains("active")
          ) {
            this.classList.remove("active");
          }
        });
      }
    });

    splideIngr.on("move", function (slide) {
      const slidesIngr = root.querySelectorAll(".co_home_section_8-slide");
      slidesIngr.forEach(function (slidesIngrItem, index) {
        slidesIngrItem.classList.remove("active");
      });
    });
  }

  // Our Story Hero Section
  var carAcc = root.querySelector(".co_ourstory_section_1-tabs");
  let coCar1ItemsImages = root.querySelectorAll(
    ".co_ourstory_section_1-tabs-item--image img"
  );

  if (carAcc) {
    var accItems = carAcc.querySelectorAll(
      ".co_ourstory_section_1-tabs-item--heading"
    );

    // Hide the next sibling element for each item (the content associated with the title)
    accItems.forEach(function (accItem, index) {
      var nextElement = accItem.nextElementSibling;
      makeToggle(accItem, nextElement, index === 0 || accItem.parentElement.classList.contains("active"), "story-" + index);

      if (index === 0 || accItem.parentElement.classList.contains("active")) {
        gsap.to(nextElement, {
          height: "auto",
          duration: reducedMotion ? 0 : 0.3,
          ease: "power2.inOut",
        });
        gsap.to(coCar1ItemsImages[index], {
          className: "z-img-absolute active",
        });
      } else {
        gsap.to(nextElement, {
          height: 0,
          duration: reducedMotion ? 0 : 0.3,
          ease: "power2.inOut",
        });
        gsap.to(coCar1ItemsImages[index], {
          className: "z-img-absolute",
        });
      }

      // Add a click event listener to each item
      listen(accItem, "click", function (e) {
        e.preventDefault();

        // Check if the parent element already has the 'active' class
        if (!this.parentElement.classList.contains("active")) {
          // If not active, hide all other sections
          accItems.forEach(function (otherAccItem, otherIndex) {
            otherAccItem.parentElement.classList.remove("active");
            updateToggle(otherAccItem, false);
            gsap.to(otherAccItem.nextElementSibling, {
              height: 0,
              duration: reducedMotion ? 0 : 0.3,
              ease: "power2.inOut",
            });
            gsap.to(coCar1ItemsImages[otherIndex], {
              className: "z-img-absolute",
            });
          });

          // Add 'active' class to the clicked item and show its content
          this.parentElement.classList.add("active");
          updateToggle(this, true);

          gsap.to(nextElement, {
            height: "auto",
            duration: reducedMotion ? 0 : 0.3,
            ease: "power2.inOut",
          });
          gsap.to(coCar1ItemsImages[index], {
            className: "z-img-absolute active",
          });
        }
        // If already active, don't hide the content
      });
    });

    var firstItem = root.querySelector(".co-career-section-1-tabs-item");
    if (firstItem) {
      firstItem.classList.add("active");

      // Show the content of the first item's title
      var firstTitle = firstItem.querySelector(
        ".co-career-section-1-tabs-item--heading"
      );
      if (firstTitle && firstTitle.nextElementSibling) {
        gsap.to(firstTitle.nextElementSibling, {
          height: "auto",
          duration: reducedMotion ? 0 : 0.3,
          ease: "power2.inOut",
        });
      }
    }
  }
  // Our Story Hero Section

  // Select the element with the class 'co_faq_section_3'
  var faq = root.querySelector(".co_faq_section_3");

  if (faq) {
    var accItems = faq.querySelectorAll(
      ".co_faq_section_3-item .co_faq_section_3-item--title"
    );

    accItems.forEach(function (accItem, index) {
      var nextElement = accItem.nextElementSibling;
      if (nextElement) {
        makeToggle(accItem, nextElement, false, "faq-" + index);
        nextElement.classList.add("text-hidden");

        gsap.to(nextElement, {
          height: 0,
          duration: reducedMotion ? 0 : 0.3,
          ease: "power2.inOut",
        });
      }
    });

    // Add a click event listener to each item
    accItems.forEach(function (accItem) {
      listen(accItem, "click", function (e) {
        e.preventDefault();

        // Toggle the 'active' class on the parent element
        this.parentElement.classList.toggle("active");
        updateToggle(this, this.parentElement.classList.contains("active"));

        // Toggle the display of the next sibling element (the content)
        var nextElement = this.nextElementSibling;
        if (nextElement) {
          if (nextElement.classList.contains("text-hidden")) {
            nextElement.classList.remove("text-hidden");
            gsap.to(nextElement, {
              height: "auto",
              duration: reducedMotion ? 0 : 0.3,
              ease: "power2.inOut",
            });
          } else {
            nextElement.classList.add("text-hidden");
            gsap.to(nextElement, {
              height: 0,
              duration: reducedMotion ? 0 : 0.3,
              ease: "power2.inOut",
            });
          }
        }
      });
    });
  }
  }, root);
  coSectionControllers.set(root, () => {
    events.abort();
    sliders.forEach((slider) => slider.destroy());
    context.revert();
    restores.forEach((restore) => restore());
    coSectionControllers.delete(root);
  });
}

function destroyCoSection(root) {
  coSectionControllers.get(root)?.();
}

function initializeCoSections() {
  document.querySelectorAll(".shopify-section").forEach(initializeCoSection);
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeCoSections, { once: true });
else initializeCoSections();
document.addEventListener("shopify:section:load", (event) => {
  initializeCoSection(event.target);
  window.ScrollTrigger?.refresh();
});
document.addEventListener("shopify:section:unload", (event) => {
  destroyCoSection(event.target);
  window.ScrollTrigger?.refresh();
});
document.addEventListener("shopify:section:reorder", () => window.ScrollTrigger?.refresh());
coMotionPreference.addEventListener("change", () => {
  document.querySelectorAll(".shopify-section").forEach((root) => {
    destroyCoSection(root);
    initializeCoSection(root);
  });
});


// function imageScrollScale(target, trigger, triggerPosStart, triggerPosEnd, scaleFrom, scaleTo) {
//     // default paramaters
//     target = target || false;
//     trigger = trigger || false;
//     triggerPosStart = triggerPosStart || 'top';
//     triggerPosEnd = triggerPosEnd || 'bottom';
//     scaleFrom = scaleFrom || 0.1;
//     scaleTo = scaleTo || 1;
//     gsap.set(target, { scale: scaleFrom });
//     gsap.to(target, {
//         scrollTrigger: {
//             trigger: trigger,
//             toggleActions: "restart none none reverse",
//             // markers: true,
//             start: "" + triggerPosStart + " bottom",
//             end: "" + triggerPosEnd + " top",
//             scrub: true
//         },
//         scale: scaleTo
//     });
// }

function coMoveOnScroll(target, trigger, endTrigger, xPercent, yPercent) {
  // default paramaters
  target = target || false;
  trigger = trigger || false;
  endTrigger = endTrigger || false;
  xPercent = xPercent || 0;
  yPercent = yPercent || 0;

  gsap.set(target, { xPercent: 0, transition: 0 });
  gsap.to(target, {
    scrollTrigger: {
      trigger: trigger,
      endTrigger: endTrigger,
      start: "top top",
      end: "bottom top",
      scrub: true,
    },
    xPercent: xPercent,
    yPercent: yPercent,
  });
}

function coFadeStale(image, root = document) {
  const images = root.querySelectorAll(image);
  if (coMotionPreference.matches) { gsap.set(images, { opacity: 1, yPercent: 0 }); return; }

  images.forEach((imageItem, index) => {
    let timeline = gsap.timeline();

    gsap.set(imageItem, { opacity: 0, yPercent: 0 });

    timeline.to(imageItem, {
      duration: 0.8,
      opacity: 1,
      ease: "power2.out",
      delay: index * 0.2,
    });

    ScrollTrigger.create({
      trigger: imageItem,
      start: "top bottom",
      end: "bottom bottom",
      toggleActions: "play none none none",
      animation: timeline,
    });
  });
}

function coFadeIn(image, root = document) {
  const images = root.querySelectorAll(image);
  if (coMotionPreference.matches) { gsap.set(images, { opacity: 1, yPercent: 0 }); return; }

  images.forEach((imageItem, index) => {
    let timeline = gsap.timeline();

    gsap.set(imageItem, { opacity: 0, yPercent: 20 });

    timeline.to(imageItem, {
      duration: 0.8,
      opacity: 1,
      yPercent: 0,
      ease: "power2.out",
      delay: index * 0.2,
    });

    ScrollTrigger.create({
      trigger: imageItem,
      start: "top bottom",
      end: "bottom bottom",
      toggleActions: "play none none none",
      animation: timeline,
    });
  });
}
